import { ExcelIcon, WordIcon } from "@/components/icons";
import { baseURL } from "@/lib/fetcher";
import { ResourceType } from "@/lib/types/resource";
import {
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileText,
  FileVideo
} from "lucide-react";
import mime from "mime-types";

export function getFileUrl(id: string | null) {
  if (!id) return "/placeholder.svg";
  // if starts with http or https, or is data:image, return the id
  if (id.startsWith("http") || id.startsWith("https") || id.startsWith("data:image")) {
    return id;
  }
  return `${baseURL}/api/v1/files/view/${id}`;
}

export const downloadFile = async (
  fileUrl: string,
  opts?: { fileName: string; extension?: string }
) => {
  try {
    const response = await fetch(fileUrl);
    console.log("response", response);
    const responseHeaders = response.headers;
    const contentType = responseHeaders.get("content-type");
    console.log("contentType", contentType);
    const extension = getFileExtension(contentType ?? undefined);
    console.log("extension", extension);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download =
      opts?.fileName ??
      `file-${new Date().toISOString()}.${opts?.extension ?? extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const getFileExtension = (contentType?: string) => {
  if (!contentType) return "pdf";
  const extension = mime.extension(contentType);
  return extension || "pdf"; // fallback to pdf if no extension is found
};

export function isYouTubeLink(url: string) {
  const regex =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/|youtube-nocookie\.com\/embed\/)[\w-]{11}(?:[&?#]\S*)?$/;
  return regex.test(url);
}

export const getFileIcon = (fileType: string, resType?: ResourceType) => {
  const mimeType = mime.extension(fileType) || '';
  // console.log('mimeType ++', mimeType)

  if (fileType.startsWith('image/') || resType === 'IMAGE') return FileImage;
  if (fileType.startsWith('video/') || resType === 'VIDEO') return FileVideo;
  if (fileType.startsWith('audio/')) return FileAudio;
  if (mimeType.includes('spreadsheet') || mimeType.includes('xlsx') || mimeType.includes('csv')) return ExcelIcon;
  if (mimeType.includes('pdf')) return FileText;
  if (mimeType.includes('word') || mimeType.includes('doc')) return WordIcon;
  if (mimeType.includes('code') || mimeType.includes('text')) return FileCode;
  if (mimeType.includes('zip') || mimeType.includes('archive')) return FileArchive;
  
  return FileText;
};